import $ from "jquery";

const quiz = {

    init: async () => {
        $(() => {
            $("input[type=radio]").on("click", (e) => {
                const correct = $(e.target).attr("name").split("-")[2];
                const value = $(e.target).val();
                const $choicelist = $(e.target).closest(".choicelist");

                // disable list
                $choicelist.find("input[type=radio]").attr("disabled", true);
                // add hidden information about choice for final result resolvement
                $choicelist.append(`<input type="hidden" name="answers.${correct}:record" value="${value}">`);

                // outline correct and possible false answer
                $(`input[value="${correct}"]`, $choicelist).closest(".form-check").addClass("border border-success");
                if(value !== correct) {
                    $(`input[value="${value}"]`, $choicelist).closest(".form-check").addClass("border border-danger");
                }
            });
        });
    }
};

export default quiz;
